import { ROUTE } from "../../../routes";
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
import SharedPropsService from "../../../SharedPropsService";
import { InputStateToken } from "@voltmoney/schema";
import { nextStepId } from "../../../configs/utils";
export const CreateDisbursementRequest = async (action, _datastore, { network, navigate, setDatastore }) => {
    await setDatastore(ROUTE.EMAIL_VERIFY_OTP, "otpModalScreen", {
        state: InputStateToken.DEFAULT,
    });
    const response = await network.post(`${api.triggerEmailOtp}`, {
        borrowerAccountId: (await SharedPropsService.getUser())
            .linkedBorrowerAccounts[0].accountId,
        emailId: action.payload.emailId
    }, { headers: await getAppHeader() });
};
export const DisbursalVerifyAction = async (action, _datastore, { navigate, network, setDatastore, goBack, instrumentTrack }) => {
    const noOfOtpDigits = action?.payload?.noOfOtpDigits;
    if (`${action.payload.value}`.length > (noOfOtpDigits - 1)) {
        await setDatastore(ROUTE.EMAIL_VERIFY_OTP, "otpModalScreen", {
            state: InputStateToken.LOADING,
        });
        const response = await network.post(api.verifyEmail, {
            otp: action.payload.value,
            emailId: action.payload.emailId
        }, { headers: await getAppHeader() }, async () => {
            await setDatastore(ROUTE.EMAIL_VERIFY_OTP, "amountItem", {
                state: InputStateToken.DEFAULT,
                value: '0',
            });
        });
        if (response.status === 200) {
            const userContextResponse = await network.post(api.userContext, {}, {
                headers: await getAppHeader(),
            });
            await SharedPropsService.setUser(userContextResponse.data);
            const route = await nextStepId(userContextResponse.data.linkedApplications[0].currentStepId);
            await setDatastore(ROUTE.EMAIL_VERIFY_OTP, "otpModalScreen", {
                state: InputStateToken.SUCCESS,
            });
            await goBack();
            navigate(route.routeId, route.params);
        }
        else {
            if (response?.response?.status === 400) {
                if (response?.response?.data?.voltErrorCode === 'ACCOUNT_BLOCKED_FROM_OTP') {
                    await setDatastore(ROUTE.EMAIL_VERIFY_OTP, "otpModalScreen", {
                        state: InputStateToken.DISABLED,
                        caption: { error: response?.response?.data?.message },
                        otpLimitExceeded: true
                    });
                }
                else {
                    await setDatastore(ROUTE.EMAIL_VERIFY_OTP, "otpModalScreen", {
                        state: InputStateToken.ERROR,
                        caption: { error: response?.response?.data?.message }
                    });
                }
            }
            else {
                await setDatastore(ROUTE.EMAIL_VERIFY_OTP, "otpModalScreen", {
                    state: InputStateToken.ERROR,
                    caption: { error: response?.response?.data?.message }
                });
            }
        }
    }
};
export const goBack = async (action, _datastore, { setDatastore, goBack }) => {
    await setDatastore(ROUTE.EMAIL_VERIFY_OTP, "otpModalScreen", {
        state: InputStateToken.DEFAULT,
        caption: {}
    });
    goBack();
};
